/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 *
 * @export
 * @interface MeasureLocationGridEventState
 */
export interface MeasureLocationGridEventState {
  /**
   *
   */
  state: EventStateEnum;
  /**
   *
   */
  stateDetail: any | null;
  /**
   *
   */
  gridId?: number | null;
  /**
   *
   */
  locationGridIds?: Array<number | null> | null;
  /**
   *
   */
  locationResourceIds?: Array<number | null> | null;
  /**
   *
   */
  locationResourceStates?: Array<string | null> | null;
  /**
   *
   */
  locationResourceStateDetails?: Array<any | null> | null;
}

/**
 * Check if a given object implements the MeasureLocationGridEventState interface.
 */
export function instanceOfMeasureLocationGridEventState(
  value: object
): value is MeasureLocationGridEventState {
  if (!("state" in value) || value["state"] === undefined) return false;
  if (
    (!("stateDetail" in (value as Record<string, any>)) &&
      !("state_detail" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["stateDetail"] === undefined &&
      (value as Record<string, any>)["state_detail"] === undefined)
  )
    return false;
  return true;
}

export function MeasureLocationGridEventStateFromJSON(json: any): MeasureLocationGridEventState {
  return MeasureLocationGridEventStateFromJSONTyped(json, false);
}

export function MeasureLocationGridEventStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MeasureLocationGridEventState {
  if (json == null) {
    return json;
  }
  return {
    state: EventStateEnumFromJSON(json["state"]),
    stateDetail: json["state_detail"],
    gridId:
      json["grid_id"] === undefined ? undefined : json["grid_id"] === null ? null : json["grid_id"],
    locationGridIds:
      json["location_grid_ids"] === undefined
        ? undefined
        : json["location_grid_ids"] === null
        ? null
        : json["location_grid_ids"],
    locationResourceIds:
      json["location_resource_ids"] === undefined
        ? undefined
        : json["location_resource_ids"] === null
        ? null
        : json["location_resource_ids"],
    locationResourceStates:
      json["location_resource_states"] === undefined
        ? undefined
        : json["location_resource_states"] === null
        ? null
        : json["location_resource_states"],
    locationResourceStateDetails:
      json["location_resource_state_details"] === undefined
        ? undefined
        : json["location_resource_state_details"] === null
        ? null
        : json["location_resource_state_details"],
  };
}

export function MeasureLocationGridEventStateToJSON(json: any): MeasureLocationGridEventState {
  return MeasureLocationGridEventStateToJSONTyped(json, false);
}

export function MeasureLocationGridEventStateToJSONTyped(
  value?: MeasureLocationGridEventState | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    state: EventStateEnumToJSON(value["state"]),
    state_detail: value["stateDetail"],
    grid_id: value["gridId"],
    location_grid_ids: value["locationGridIds"],
    location_resource_ids: value["locationResourceIds"],
    location_resource_states: value["locationResourceStates"],
    location_resource_state_details: value["locationResourceStateDetails"],
  };
}
